import bind from 'bind-decorator';
import delay from 'delay';
import { createPopper } from '@popperjs/core/lib/popper-lite';
import preventOverflow from '@popperjs/core/lib/modifiers/preventOverflow';
import offset from '@popperjs/core/lib/modifiers/offset';

import View from './view';
import { isMobile } from '@/helpers/mobile_detect';

export default class PopperTooltipV4 extends View {
  isShown = false;
  popper = null;
  $shade = null;

  initialize() {
    this.$trigger.on('click', this.onToggle);
    this.$tooltip
      .on('popper:show', this.show)
      .on('popper:hide', this.hide);
  }

  get $trigger() {
    return this.$node;
  }

  get $tooltip() {
    return this.$node.next();
  }

  @bind
  onToggle() {
    if (this.isShown) {
      this.onHide();
    } else {
      this.onShow();
    }
  }

  @bind
  onShow() {
    this.$trigger.trigger('popper:show');
    this.$tooltip.trigger('popper:show');
  }

  @bind
  onHide() {
    this.$trigger.trigger('popper:hide');
    this.$tooltip.trigger('popper:hide');
  }

  @bind
  onClose(e) {
    e.preventDefault();
    this.onHide();
  }

  @bind
  show() {
    this.isShown = true;
    this.$tooltip.addClass('is-visible-stage-1');

    this.$tooltip.find('.close').on('click', this.onClose);

    this.$shade = $(`
      <div class="b-tooltip-shade" />
    `)
      .on('click', this.onHide)
      .insertAfter(this.$tooltip);

    requestAnimationFrame(() => {
      this.$shade.addClass('is-visible');

      if (!isMobile()) {
        this.popper = createPopper(
          this.$trigger[0],
          this.$tooltip[0],
          {
            placement: this.$trigger.data('placement'),
            modifiers: [
              preventOverflow,
              offset, {
                name: 'preventOverflow',
                options: { padding: 10 }
              }, {
                name: 'offset',
                options: { offset: [0, 16] }
              },
              { name: 'eventListeners', enabled: isMobile() }
            ]
          }
        );
      }
      this.$tooltip.addClass('is-visible-stage-2');
    });

    $(document).one('turbolinks:before-cache', this.onHide);
  }

  @bind
  async hide() {
    if (!this.isShown) { return; }

    this.isShown = false;

    this.$tooltip.removeClass('is-visible-stage-2');
    if (this.$shade) {
      this.$shade.removeClass('is-visible');
    }
    await delay(300); // animation duration
    this.$tooltip.removeClass('is-visible-stage-1');

    if (this.isShown) { return; }

    this.$tooltip.find('.close').off('click', this.onClose);

    if (this.$shade) {
      this.$shade.remove();
    }

    if (this.popper) {
      this.popper.destroy();
      this.popper = null;
    }
  }
}
